<template>
  <div class="guanLi">
    <statistics v-loading="sLoading" :list="statistics" :data="sData"></statistics>

    <div class="card-row">
      <chart-bar4 class="row-col space-item" chart-id="bar-ratio1" source="type" />
      <chart-bar4 class="row-col space-item" chart-id="bar-ratio2" source="time" />
    </div>

    <div class="card-row">
      <chart-bar1 class="row-col" chart-id="bar-city" source="glNumCity" />
    </div>

    <div class="card-row">
      <chart-pie1
        v-if="isXcPie === 'serviceXc'"
        key="serviceXc"
        class="row-col space-item"
        style="flex: 1"
        click-title
        chart-id="pie-1"
        source="serviceXc"
        @click-title="handleTitle"
      />
      <chart-pie1
        v-if="isXcPie === 'serviceXc_1'"
        key="serviceXc_1"
        class="row-col space-item"
        style="flex: 1"
        click-title
        chart-id="pie-1"
        source="serviceXc_1"
        @click-title="handleTitle"
      />
      <chart-pie1 class="row-col space-item" style="flex: 1" chart-id="pie-2" source="serviceYw" />
      <chart-bar-line class="row-col space-item" style="flex: 2" chart-id="bar-line-1" />
    </div>
  </div>
</template>

<script>
import Statistics from './components/statistics'
import ChartBar1 from './components/ChartBar1'
import ChartBar4 from './components/ChartBar4'
import ChartPie1 from './components/ChartPie1'
import ChartBarLine from './components/ChartBarLine'

/**
 * 管理 看板
 */
export default {
  name: 'viewGuanLi',
  components: { Statistics, ChartBar1, ChartBar4, ChartPie1, ChartBarLine },
  data() {
    return {
      /** @type {import('./index.vue').IRoleId */
      roleId: 'guanLi',
      statistics: [
        { num: 0, field: 'THIS_MONTH_WORK', tip: '本月总服务请求' },
        { num: 0, field: 'THIS_WEEK_WORK', tip: '本周总服务请求' },
        { num: 0, field: 'LAST_WEEK_WORK', tip: '上周总服务请求' },
        { num: 0, field: 'THIS_MONTH_SERVICE', tip: '本月总现场服务单' },
        { num: 0, field: 'THIS_WEEK_SERVICE', tip: '本周总现场服务单' },
        { num: 0, field: 'LAST_WEEK_SERVICE', tip: '上周总现场服务单' },
      ],
      sData: {},
      sLoading: false,
      isXcPie: 'serviceXc',
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    handleTitle: function (e) {
      this.isXcPie = e
    },
    getData: function () {
      let condition = {},
        roleId = this.roleId
      this.sLoading = true
      this.api.queryList('YW_STATISTICS_GUANLI', { p2: condition, p9: '' }, `${roleId}_statistics`).then(
        (res) => {
          this.sLoading = false
          let resData = res.result
          this.sData = resData[0] || {}
        },
        (err) => {
          this.sLoading = false
        }
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/viewBoard/viewGuanLi.vue